import { envToBoolean } from './utils';

export const SHOW_DATA_COLLECTION_HEADLINE = envToBoolean(process.env.NEXT_PUBLIC_SHOW_DATA_COLLECTION_HEADLINE);
